import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NoDataComponent } from 'ngx-lib';

@Component({
    selector: 'app-report-single-empty-state',
    standalone: true,
    imports: [NoDataComponent],
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `<lib-no-data [iconName]="iconName()" [title]="title()" [text]="text()"></lib-no-data>`
})
export class ReportSingleEmptyStateComponent {
    iconName = input<string>('click');
    title = input<string>("It seems there's nothing here yet.");
    text = input<string>('Apply the filters to find relevant content based on your search.');
}
